import React from "react";

import { useQuery } from "@apollo/client";

import Grid from "@material-ui/core/Grid";

import panelVirtualInstrumentsQuery from "./panel-virtual-instruments-query";

import { SERVER_URI } from "../../constants";

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  // panelName: String;
  panelDefinition: any;
  // startDate: number; // Date;
  // endDate: number; // Date;
  // widgetStatic?: boolean;
  // widgetTitle?: string;
}

function PanelVirtualInstrumentsContainer(props: Props) {
  const {
    nodes,
    panelCollectionName,
    // panelId,
    panelDefinition,
    // startDate,
    // endDate,
    // widgetStatic,
    // widgetTitle,
  } = props;
  const n = nodes ? nodes.join(",") : undefined;
  const { data, error, loading } = useQuery(panelVirtualInstrumentsQuery, {
    variables: {
      panelName: panelDefinition?.template,
      panelCollectionName: panelCollectionName,
      tab: panelDefinition?.id,
      node: n,
      // view: "vi",
    },
  });
  // console.log("iconLink data", data);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }
  // console.log("stat table", data);

  return (
    <Grid container>
      {data.virtualInstruments.map((vi: any) => (
        <Grid
          key={vi.uri}
          item
          xs={6}
          sm={4}
          md={2}
          container
          justify="center"
          alignItems="flex-start"
        >
          <figure>
            <img
              style={{ width: "130px" }}
              src={`${SERVER_URI}${vi.uri}`}
              alt={vi.name}
            />
            <figcaption>{vi.name}</figcaption>
          </figure>
        </Grid>
      ))}
    </Grid>
  );
}

export default PanelVirtualInstrumentsContainer;
